import { ListInventory } from "~/components/admin/inventories";
import PageMeta from "~/components/common/meta";

export function ScreenClientInventory() {
  return (
    <>
      <PageMeta title="Inventory Management | Art Handler" />
      <ListInventory />
    </>
  );
}
